<template>
  <div class="my-violation">
    <div class="data">
      <div class="data-box">
        <div class="data-desc">
          <div>{{ data.totalPunishNum || 0 }}</div>
          <span>{{ $t('lang.HostessCenter.k023') }}</span>
        </div>
        <div class="data-desc">
          <div>{{ data.recent7daysPunishNum || 0 }}</div>
          <span>{{ handleOneText($t('lang.HostessCenter.k024'), '%s', 7) }}</span>
        </div>
      </div>
      <div class="line"></div>
      <div class="data-box">
        <div class="data-desc">
          <div class="beans">
            <img :src="getMatchImg('beans')" alt="" />
            {{ data.totalPunishBeans || 0 }}
          </div>
          <span>{{ $t('lang.HostessCenter.k022') }}</span>
        </div>
        <div class="data-desc">
          <div class="beans">
            <img :src="getMatchImg('beans')" alt="" />
            {{ data.recent7daysPunishBeans || 0 }}
          </div>
          <span>{{ handleOneText($t('lang.HostessCenter.k005'), '%s', 7) }}</span>
        </div>
      </div>
    </div>
    <div class="select">
      <div class="text">{{ $t('lang.BaseCommon.k050') }}</div>
      <div class="selete-box" @click="showSelete">
        <span>{{ seleteText }}</span>
        <img :class="{ rotate: showPopSelete }" src="@/assets/packageAssets/common/arrow06.png" alt="" />
      </div>
    </div>
    <div class="header">
      <div>{{ $t('lang.HostessCenter.k004') }}</div>
      <div>{{ $t('lang.BaseCommon.k048') }}</div>
      <div>{{ $t('lang.HostessCenter.k019') }}</div>
    </div>
    <van-list
      class="table"
      v-model="loading"
      :finished="finished"
      loading-text=" "
      :finished-text="$t('lang.BaseCommon.k087')"
      offset="200"
      @load="onLoad"
    >
      <table class="table-box">
        <tr class="td-item" v-for="item in recordList" :key="item.level">
          <td>{{ handleMoment(item.violateTime, 'DD/MM/YYYY') }}</td>
          <td>{{ item.reason }}</td>
          <td class="number">
            {{ item.punishBeans }}
            <img :src="getMatchImg('beans')" alt="" />
          </td>
        </tr>
      </table>
    </van-list>

    <Selete :columns="columns" :showPop="showPopSelete" @currentChoose="currentChoose" />
  </div>
</template>

<script>
import Selete from '@/components/CSelete/Selete.vue'
import { apiFetchPunishRecord, apiFetchPunishStatistics } from '@/api/imee'
import moment from 'moment'
export default {
  components: { Selete },
  data() {
    return {
      seleteText: this.$t('lang.BaseCommon.k003'),
      showPopSelete: false,
      columns: [
        {
          text: this.$t('lang.BaseCommon.k003'),
          id: 1,
        },
        {
          text: this.$t('lang.HostessCenter.k011'),
          id: 2,
        },
        {
          text: this.$t('lang.HostessCenter.k010'),
          id: 3,
        },
      ],
      startTime: null,
      listQuery: {
        offset: 0,
        limit: 8,
      },
      loading: false,
      finished: false,
      data: {},
      recordList: [],
    }
  },
  created() {
    this.fetchPunishRecord()
    this.fetchPunishStatistics()
  },
  methods: {
    showSelete() {
      this.showPopSelete = true
    },
    closeSeletePop() {
      this.showPopSelete = false
    },
    // 当前的选择 传给父组件
    currentChoose(val) {
      this.listQuery.offset = 0
      this.seleteText = val && val.text
      this.showPopSelete = false
      if (val && val.id == 2) {
        this.startTime = moment().subtract(7, 'days').startOf('day').unix()
      }
      if (val && val.id == 3) {
        this.startTime = moment().subtract(1, 'months').startOf('day').unix()
      }
      this.fetchPunishRecord()
    },

    // 获取违规统计
    fetchPunishStatistics() {
      apiFetchPunishStatistics().then((res) => {
        if (res) {
          this.data = res
        }
      })
    },

    // 获取list列表
    fetchPunishRecord() {
      this.loading = true
      const params = {
        ...this.listQuery,
      }
      if (this.startTime) {
        params.startTime = this.startTime * 1000
      }
      apiFetchPunishRecord(params).then((res) => {
        if (res) {
          this.loading = false
          this.recordList = this.recordList.concat(res)
          if (res.length < this.listQuery.limit) {
            this.finished = true
          } else {
            this.finished = false
          }
          this.listQuery.offset = this.recordList.length
        }
      })
    },

    // 下拉刷新
    onLoad() {
      this.fetchPunishRecord()
    },
  },
}
</script>

<style lang="less" scoped>
.my-violation {
  padding-top: 20px;
  .data {
    display: flex;
    width: 343px;
    height: 132px;
    margin: 0 auto;
    background: #ffffff;
    border-radius: 10px;
    font-family: 'Inter-Regular';
    display: flex;
    align-items: center;
    .data-box {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .data-desc {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        line-height: 24px;
        font-weight: 500;
        font-size: 20px;
        color: #333;
        > span {
          display: block;
          margin-top: 6px;
          line-height: 16px;
          font-weight: 400;
          font-size: 12px;
          color: #999999;
        }
        .beans {
          display: flex;
          align-items: center;
          > img {
            width: 16px;
            margin: 0 2px;
          }
        }
      }
      .data-desc:nth-child(2) {
        margin-top: 10px;
      }
    }
    .line {
      width: 1px;
      height: 88px;
      background: #e7e7e7;
    }
  }
  .header {
    display: flex;
    width: 343px;
    margin: 10px auto 0;
    font-size: 14px;
    line-height: 36px;
    color: #333333;
    border-right: 1px solid #e9e9e9;
    border-top: 1px solid #e9e9e9;
    > div {
      height: 36px;
      font-weight: 700;
      text-align: center;
      background-color: #f1f1f6;
    }
    div:nth-child(1) {
      width: 84px;
      border-left: 1px solid #e9e9e9;
    }
    div:nth-child(2) {
      width: 187px;
      border-left: 1px solid #e9e9e9;
    }
    div:nth-child(3) {
      flex: 1;
      border-left: 1px solid #e9e9e9;
    }
  }
  .table {
    width: 343px;
    height: 298px;
    margin: 0 auto;
    overflow-y: auto;
    padding-bottom: 10px;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
  .table-box {
    width: 343px;
    margin: 0 auto;
    font-family: 'Inter-Regular';
    font-size: 12px;
    td {
      height: 36px;
      line-height: 15px;
      text-align: center;
      border: 1px solid #e9e9e9;
      > img {
        width: 16px;
      }
    }
    td:nth-child(1) {
      width: 84px;
      color: #999999;
    }
    td:nth-child(2) {
      width: 187px;
      color: #666;
    }
    .number {
      color: #333;
      display: flex;
      align-items: center;
      justify-content: center;
      > img {
        width: 14px;
        margin: 0 2px;
      }
    }
    .td-item {
      background-color: #fff;
    }
    .td-item:nth-child(odd) {
      background-color: #fafbfd;
    }
    .tr-box {
      width: 343px;
      height: 300px;
      overflow-y: auto;
    }
  }
  .select {
    font-family: 'Inter-Regular';
    width: 343px;
    margin: 30px auto 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .text {
      font-weight: 600;
      font-size: 14px;
      color: #333333;
    }
    .selete-box {
      position: relative;
      min-width: 107px;
      height: 30px;
      padding: 0 25px;
      text-align: center;
      line-height: 30px;
      background: #ffffff;
      border-radius: 6px;
      font-weight: 400;
      font-size: 14px;
      > img {
        width: 16px;
        height: 16px;
        position: absolute;
        right: 5px;
        top: 50%;
        transform: translateY(-50%);
      }
      .rotate {
        transform: translateY(-50%) rotate(180deg);
      }
    }
  }
}
</style>
